import { Link } from 'gatsby'
import React from 'react'
import * as styles from '../styles/home.module.css'

export default function Footer() {
    return (
        <footer>
            <nav>
                <div className={styles.links}>
                    <Link to="/" className={styles.home}>Home</Link>
                    <Link to="/manifesto" className={styles.manifesto}>Manifesto</Link>
                    <Link to="/requestaccess" className={styles.requestaccess}>Request Access</Link>
                </div>
            </nav>
        </footer>
    )
}
